"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _underscore = require("underscore");
var _types = require("../../actions/attendee/types");
var _types2 = require("../../actions/program/types");
var _types3 = require("../../actions/recording/types");
var _types4 = require("../../actions/source/types");
var _types5 = require("../../actions/template/types");
var _types6 = require("../../actions/types/types.generic");
var _logSourceChanges = require("../../utils/logSourceChanges");
var _sources5 = require("../../utils/sources");
var _Sources = require("@studio/constants/Sources");
var _SourceLoadStatus = require("@studio/constants/SourceLoadStatus");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = exports.initialState = {
  isLoading: false,
  // Being used to block entry for director pro when source list hasn't been loaded yet
  loadStatus: _SourceLoadStatus.PENDING,
  sources: [],
  defaultSelectedSource: '',
  isUpdating: false,
  isCreating: false,
  isUploading: false
};
function sources() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload,
    type = action.type;
  if ([_types5.BROADCAST_CREATE_SOURCE, _types4.BROADCAST_CREATE_CONTENT_SOURCE].includes(type)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isCreating: true
    });
  }
  if (type === _types4.BROADCAST_GET_SOURCES) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: state.sources.length === 0,
      loadStatus: _SourceLoadStatus.PENDING
    });
  }
  if (type === "".concat(_types4.BROADCAST_GET_SOURCES, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      loadStatus: _SourceLoadStatus.FAILED
    });
  }
  if (type === _types4.BROADCAST_UPLOAD_SOURCE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUploading: true
    });
  }
  if (["".concat(_types5.BROADCAST_CREATE_SOURCE, "_FAILURE"), "".concat(_types4.BROADCAST_CREATE_CONTENT_SOURCE, "_FAILURE")].includes(type)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isCreating: false
    });
  }
  if (type === "".concat(_types4.BROADCAST_UPLOAD_SOURCE, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUploading: false
    });
  }
  if (type === "".concat(_types4.BROADCAST_GET_SOURCES, "_SUCCESS")) {
    var _sources = _toConsumableArray(payload.items);
    _sources = (0, _sources5.findAndUpdateEmptySourceTitle)(_sources);
    var updatedSources = (0, _sources5.retainPDFURLsInSources)(_sources, state.sources);

    // Log source changes for debugging and audit purposes
    (0, _logSourceChanges.logSourceChanges)(state.sources, updatedSources, type);
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: updatedSources,
      isLoading: false,
      loadStatus: _SourceLoadStatus.DONE,
      isCreating: false
    });
  }
  if ([_types6.BROADCAST_UPDATE_SOURCE, _types4.BROADCAST_UPDATE_CONTENT_SOURCE].includes(type)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: true
    });
  }
  if (["".concat(_types6.BROADCAST_UPDATE_SOURCE, "_SUCCESS"), "".concat(_types6.BROADCAST_UPDATE_SOURCE_THUMBNAIL, "_SUCCESS"), "".concat(_types4.BROADCAST_UPDATE_CONTENT_SOURCE_STATUS, "_SUCCESS")].includes(type)) {
    /**
     * if source is a media type and the current updated source is visible i.e
     * hidden property is false then hide all other visible source that is of
     * type media i.e hidden should be set to true
     */
    var sourceWillBeVisible = payload.hidden === false;
    var _updatedSources = _toConsumableArray(state.sources);
    if ((0, _sources5.isMediaSourceExcludeAudio)(payload) && sourceWillBeVisible) {
      _updatedSources = _updatedSources.map(function (s) {
        if ((0, _sources5.isMediaSourceExcludeAudio)(s) && s._id !== payload._id) {
          return _objectSpread(_objectSpread({}, s), {}, {
            hidden: true
          });
        }
        return s;
      });
    }
    var _sources2 = _updatedSources.map(function (s) {
      if (s._id === payload._id) {
        return _objectSpread(_objectSpread({}, s), payload);
      }
      return s;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false,
      sources: _sources2
    });
  }
  if (["".concat(_types5.BROADCAST_CREATE_SOURCE, "_SUCCESS"), "".concat(_types3.BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * Create source api performs an upsert,
     * if the source is already present in state,
     * we don't want to update the state with a duplicate source
     */
    var sourceExists = state.sources.find(function (source) {
      return source._id === payload._id;
    });
    if (sourceExists) {
      return _objectSpread(_objectSpread({}, state), {}, {
        sources: state.sources.map(function (source) {
          return source.id === payload.id ? _objectSpread(_objectSpread({}, source), {}, {
            presenterSessionId: payload.presenterSessionId
          }) : source;
        })
      });
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: [].concat(_toConsumableArray(state.sources), [payload]),
      isCreating: false
    });
  }
  if (type === "".concat(_types4.BROADCAST_UPLOAD_SOURCE, "_SUCCESS")) {
    var sourceIndex = state.sources.findIndex(function (source) {
      return source._id === payload._id;
    });
    if (sourceIndex !== -1) {
      var _updatedSources2 = _toConsumableArray(state.sources);
      _updatedSources2[sourceIndex] = payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        sources: _updatedSources2,
        isUploading: false
      });
    } else {
      return _objectSpread(_objectSpread({}, state), {}, {
        sources: [].concat(_toConsumableArray(state.sources), [payload]),
        isUploading: false
      });
    }
  }
  if (["".concat(_types4.BROADCAST_DELETE_SOURCES, "_SUCCESS"), "".concat(_types4.BROADCAST_DELETE_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * This handles when one or multiple sources is to be deleted.
     * So its either an array of all the deleted sources when `BROADCAST_DELETE_SOURCES` action is dispatched
     * or the source deleted if `BROADCAST_DELETE_SOURCE` action was dispatched
     */
    var ids = (0, _underscore.isArray)(payload) ? payload : [payload._id];
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: _toConsumableArray(state.sources).filter(function (s) {
        return !ids.includes(s._id);
      })
    });
  }
  if (type === "".concat(_types4.BROADCAST_REORDER_SOURCES, "_SUCCESS")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      sources: (0, _sources5.findAndUpdateSource)(state.sources, payload)
    });
  }
  if (type === _types2.BROADCAST_PROGRAM_SOURCES_SYNC) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false,
      sources: (0, _sources5.sourcesWithPreviousDisconnectedState)(payload, state.sources)
    });
  }
  if (type === "".concat(_types6.BROADCAST_UPDATE_SOURCE, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false
    });
  }
  if (type === _types4.BROADCAST_DISCONNECT_SOURCE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (s._id === payload.sourceId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            disconnected: true
          });
        }
        return s;
      })
    });
  }
  if (type === _types4.BROADCAST_CANCEL_SOURCE_DISCONNECT) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (s._id === payload.sourceId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            disconnected: false
          });
        }
        return s;
      })
    });
  }
  if (type === "".concat(_types6.BROADCAST_CREATE_SOURCES, "_SUCCESS")) {
    //filter out the sources in payload if they are already present in the state
    var updatedPayload = payload.filter(function (source) {
      return !state.sources.find(function (s) {
        return s.value === source.value;
      });
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: [].concat(_toConsumableArray(state.sources), _toConsumableArray(updatedPayload)),
      isCreating: false
    });
  }
  if (type === _types4.BROADCAST_INITIALIZING_SOURCE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (s._id === payload.sourceId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            isInitializing: payload.isInitializing
          }, payload.presenterSessionId !== undefined && {
            presenterSessionId: payload.presenterSessionId
          });
        }
        return s;
      })
    });
  }
  if (type === _types4.BROADCAST_SOURCES_TRANSCODING_STATUS) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: payload
    });
  }
  if (type === "".concat(_types4.BROADCAST_RESET_SOURCES, "_SUCCESS")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: payload ? (0, _sources5.findAndUpdateSource)(state.sources, payload) : state.sources
    });
  }

  /*
  source.value should not be UNASSIGNED to avoid setting the name
  of all unassigned source to the same name in director PRO
  */
  if (type === _types.BROADCAST_SET_ATTENDEE_NAME) {
    var isValidAttendeeId = payload.attendeeId !== _Sources.UNASSIGNED && payload.attendeeId !== '';
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (isValidAttendeeId && s.value === payload.attendeeId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            title: payload.name
          });
        }
        return s;
      })
    });
  }
  if (["".concat(_types4.BROADCAST_CREATE_CONTENT_SOURCE_STATUS, "_SUCCESS"), "".concat(_types4.BROADCAST_CREATE_CONTENT_SOURCE_STATUS, "_FAILURE"), "".concat(_types4.BROADCAST_UPDATE_CONTENT_SOURCE_STATUS, "_FAILURE")].includes(type) && _Sources.S3SourceTypes.includes(payload.type)) {
    var _updatedSources3 = _toConsumableArray(state.sources);
    var _sources3 = _updatedSources3.map(function (source) {
      if (source._id === payload._id) {
        return _objectSpread(_objectSpread({}, source), payload);
      }
      return source;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false,
      isCreating: false,
      sources: _sources3
    });
  }
  if (type === "".concat(_types4.BROADCAST_UPDATE_CONTENT_SOURCE, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false
    });
  }
  if (["".concat(_types4.BROADCAST_UPDATE_CONTENT_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * Create source api performs an upsert,
     * if the source is already present in state,
     * we don't want to update the state with a duplicate source
     */
    var _updatedSources4 = _toConsumableArray(state.sources);
    var _sources4 = _updatedSources4.map(function (source) {
      if (source._id === payload._id) {
        return _objectSpread(_objectSpread({}, source), payload);
      }
      return source;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: _sources4,
      isUpdating: _Sources.S3SourceTypes.includes(payload.type)
    });
  }
  if (["".concat(_types4.BROADCAST_CREATE_CONTENT_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * Create source api performs an upsert,
     * if the source is already present in state,
     * we don't want to update the state with a duplicate source
     */
    var _sourceExists = state.sources.find(function (source) {
      return source._id === payload._id;
    });
    if (_sourceExists) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: [].concat(_toConsumableArray(state.sources), [payload]),
      isCreating: _Sources.S3SourceTypes.includes(payload.type)
    });
  }
  if (type === "".concat(_types4.BROADCAST_GET_SOURCE, "_SUCCESS")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (source) {
        if (source._id === payload._id) {
          return _objectSpread(_objectSpread({}, source), payload);
        }
        return source;
      })
    });
  }
  return state;
}
var _default = exports["default"] = sources;